/**
 *  Asserts if the environment is in `dev` mode
 *
 * @returns {boolean} `true` | `false`
 */
export const __DEV__ = process.env.NODE_ENV !== 'production';
